import { useRef, useState } from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import styled from 'styled-components';
import ChevronIcon from '../icons/ChevronIcon';
import { SoilAttribute } from '../../types/soilAttributes';
import { SOIL_ATTRIBUTES } from '../../constants/soil-attributes/soilAttributes';
import GroupedTypeahead from '../GroupedTypeahead';
import { sidePanelTypeaheadStyles } from '../basics/StandardTypeahead';

const StyledDropdownMenu = styled(DropdownMenu)`
  max-height: 400px;
  font-size: inherit;
`;

const InlineGroupedTypeahead = styled(GroupedTypeahead)`
  .rbt-input-main {
    margin: 0 24px;
  }
  ${sidePanelTypeaheadStyles}
  .rbt-menu.dropdown-menu {
    align-self: end;
    position: static !important;
    width: 100%;
    transform: none !important;
    border: none;
    overflow: scroll;
    max-height: 400px !important;
  }
`;

const SoilAttributeDropdown = ({
  activeAttribute,
  setActiveAttribute,
}: {
  activeAttribute: SoilAttribute;
  setActiveAttribute: (attribute: SoilAttribute) => void;
}) => {
  const typeaheadRef = useRef<Typeahead>();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
    // Autofocus the typeahead
    setTimeout(() => typeaheadRef.current?.focus(), 50);
  };

  const onChange = ([option]: SoilAttribute[]) => {
    setActiveAttribute(option);
    setDropdownOpen(false);
    typeaheadRef.current?.clear();
    typeaheadRef.current?.blur();
  };
  const onKeyDown = (e: KeyboardEvent) => {
    if (e.code === 'Escape') toggleDropdown();
  };

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
      <DropdownToggle
        className="d-flex align-items-center text-left mb-2"
        size="sm"
      >
        {activeAttribute?.name || 'Select attribute'}
        <ChevronIcon className="ml-2" direction="down" />
      </DropdownToggle>
      <StyledDropdownMenu
        container="body"
        style={{ zIndex: 1050 }}
        modifiers={{ preventOverflow: { boundariesElement: 'viewport' } }}
        onKeyDown={onKeyDown}
      >
        <InlineGroupedTypeahead
          // @ts-expect-error GroupedTypeahead not migrated to TS
          id="soilAttributeTypeahead"
          labelKey="name"
          minWidth="330px"
          onChange={onChange}
          open
          optionGroups={SOIL_ATTRIBUTES}
          placeholder="Search attributes..."
          ref={typeaheadRef}
          selectedOption={activeAttribute?.name}
          showOverflow
          showTitle={false}
        />
      </StyledDropdownMenu>
    </Dropdown>
  );
};

export default SoilAttributeDropdown;
